import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { normalize } from '../../../helpers/pagination';
import { setAccessToken } from "../../../mixins/insight/setAccessToken";

const state = {
  folderStructure: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_FOLDER_STRUCTURE_BUSY: (state, payload) => {
    state.folderStructure.isBusy = payload;
  },
  LOAD_FOLDER_STRUCTURE_SUCCESS: (state, payload) => {
    state.folderStructure.isBusy = false;
    state.folderStructure.data = payload.data;
    state.folderStructure.error = null;
  },
  LOAD_FOLDER_STRUCTURE_FAIL: (state, payload) => {
    state.folderStructure.isBusy = false;
    state.folderStructure.data = null;
    state.folderStructure.error = payload;
  },

  DELETE_FOLDER_STRUCTURE_BUSY: (state, payload) => {
    state.folderStructure.isBusy = payload;
  },
  DELETE_FOLDER_STRUCTURE_SUCCESS: (state, payload) => {
    state.folderStructure.isBusy = false;

    let folderStructure = state.folderStructure.data;
    if(Object.keys(payload.data).length > 0) {
      state.folderStructure.data = folderStructure.filter(folder => folder.id !== payload.data.id);
    }

    state.folderStructure.error = null;
  },
  DELETE_FOLDER_STRUCTURE_FAIL: (state, payload) => {
    state.folderStructure.isBusy = false;
    state.folderStructure.error = payload;
  }
};


const actions = {
  getFolderStructure: ({ commit, rootState }, { projectId }) => {
    commit('LOAD_FOLDER_STRUCTURE_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    Axios
      .get(`${API_HOST}/projects/${projectId}/folder_structure`, config)
      .then(response => {
        commit('LOAD_FOLDER_STRUCTURE_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('LOAD_FOLDER_STRUCTURE_FAIL', error)
      })
  },

  addFolder: ({ commit, rootState }, { projectId, model }) => {
    commit('LOAD_FOLDER_STRUCTURE_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    Axios
      .post(`${API_HOST}/projects/${projectId}/folder_structure`, model, config)
      .then(response => {
        commit('LOAD_FOLDER_STRUCTURE_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('LOAD_FOLDER_STRUCTURE_FAIL', error)
      })
  },

  deleteFolder: ({ commit, rootState }, { projectId, folderId }) => {
    commit('DELETE_FOLDER_STRUCTURE_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    Axios
      .delete(`${API_HOST}/projects/${projectId}/folder_structure/${folderId}`, config)
      .then(response => {
        commit('DELETE_FOLDER_STRUCTURE_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('DELETE_FOLDER_STRUCTURE_FAIL', error)
      })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};